<template>
    <div class="main">

      <div class="top-section">
        <el-row class="list-header">
        <el-col :span="24" class="section-header" :gutter="20" >
          <div class="section-title">Calculadora de Inversión Aseguradora vs Tradicional</div>
        </el-col>
      </el-row>
      </div>

      <el-row class="graph-form"  :gutter="10">
        <el-col class="card-col col-form"  :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
          <el-card class="box-card" >

            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="auto" class="graph-form" size="mini" label-position="right" >

              <el-row :gutter="1">
                <el-col  :xs="12" :sm="12" :md="24" :lg="24" :xl="24">
                  <el-form-item label="Capital Inicial" prop="capital" class="label-title">
                    <el-input  v-model.lazy="ruleForm.capital" v-money="money" autofocus></el-input>
                    <!--<money v-model="ruleForm.capital" v-bind="money" class="form-input input-lg"></money>   {{ruleForm.capital}}-->
                  </el-form-item>
                </el-col >
                <el-col  :xs="12" :sm="12" :md="24" :lg="24" :xl="24">
                  <el-form-item label="Tasa Nominal" prop="tasa_nominal" class="label-title">
                    <el-input  v-model.lazy="ruleForm.tasa_nominal" v-money="money_p" ></el-input>
                    <!--<money v-model="ruleForm.tasa_nominal" v-bind="money_p" class="form-input input-lg"></money> {{ruleForm.tasa_nominal}}  -->
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="1">
                <el-col  :xs="12" :sm="12" :md="24" :lg="24" :xl="24">
              <el-form-item label="Inflación" prop="inflacion" class="label-title">
                <el-input  v-model.lazy="ruleForm.inflacion" v-money="money_p" ></el-input>
                <!--<money v-model="ruleForm.inflacion" v-bind="money_p" class="form-input input-lg"></money> {{ruleForm.inflacion}}  -->
              </el-form-item>
                </el-col>
                <el-col  :xs="12" :sm="12" :md="24" :lg="24" :xl="24">
              <el-form-item label="Tasa Real" class="label-title">
                <el-input  :value="result" v-money="money_p" disabled></el-input>
                <!--<money v-model="ruleForm.tasa_real" v-bind="money_p" class="form-input input-lg"></money> {{ruleForm.tasa_real}}  -->
              </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="1">
                <el-col  :xs="12" :sm="12" :md="24" :lg="24" :xl="24">
              <el-form-item label="Tasa ISR" prop="tasa_isr" class="label-title">
                <el-input  v-model.lazy="ruleForm.tasa_isr" v-money="money_p" ></el-input>
                <!--<money v-model="ruleForm.tasa_isr" v-bind="money_p" class="form-input input-lg"></money> {{ruleForm.tasa_isr}}  -->
              </el-form-item>
                </el-col>
                <el-col  :xs="12" :sm="12" :md="24" :lg="24" :xl="24">
              <el-form-item label="Tasa Ret. Prov" prop="tasa_ret_prov" class="label-title">
                <el-input  v-model.lazy="ruleForm.tasa_ret_prov" v-money="money_p" ></el-input>
                <!--<money v-model="ruleForm.tasa_ret_prov" v-bind="money_p" class="form-input input-lg"></money> {{ruleForm.tasa_ret_prov}}  -->
              </el-form-item>
                </el-col>
              </el-row>

              <div class="block">
                <span class="label-title">Rango de Tiempo</span>
                <el-slider  v-model="sliderY" :min="10" :step="5" :max="40" :marks="marks">
                </el-slider>
              </div>

              <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">Gráfica</el-button>
                <!-- <el-button @click="resetForm('ruleForm')">Reset</el-button> -->
              </el-form-item>
            </el-form>
          </el-card>
        </el-col>

        <el-col class="col-chart"  :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
          <div id="tooltip" class="hidden">
            <p><strong  style="color:#4366de">Aseguradora</strong></p>
            <p><span  style="color:#4366de" id="valueA">100</span></p>
            <p><strong style="color:#fd6b7d">Tradicional</strong></p>
            <p><span style="color:#fd6b7d" id="valueT">100</span></p>
            <p><strong  style="color:#001F5C">Diferencia a</strong></p>
            <p><span style="color:#001F5C" id="valueD">100</span></p>
          </div>
          <!--<p class="label">Test</p>-->
          <div ref="chartwrapper" class="chartwrapper"></div>
        </el-col>
      </el-row>

      <el-row id="cards-info"  class="row-info" :gutter="15" >
        <el-col class="card-col" :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
          <el-card id="card-info1" class="info-card card-10">
            <div>
              <p><strong  style="color:#001F5C" id="info1-D">100</strong></p>
              <p><strong  style="color:#4366de" id="info1-A">100</strong></p>
              <p><strong style="color:#fd6b7d" id="info1-T">100</strong></p>
            </div>
          </el-card>
        </el-col>
        <el-col class="card-col" :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
          <el-card class="info-card card-20" >
            <div>
              <p><strong  style="color:#001F5C" id="info2-D">100</strong></p>
              <p><strong  style="color:#4366de" id="info2-A">100</strong></p>
              <p><strong style="color:#fd6b7d" id="info2-T">100</strong></p>
            </div>
          </el-card>
        </el-col>
        <el-col class="card-col" :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
          <el-card class="info-card card-30" >
            <div>
              <p><strong  style="color:#001F5C" id="info3-D">100</strong></p>
              <p><strong  style="color:#4366de" id="info3-A">100</strong></p>
              <p><strong style="color:#fd6b7d" id="info3-T">100</strong></p>

            </div>
          </el-card>
        </el-col>
      </el-row>

    </div>
</template>

<script>

  import {getCalculation} from "../graphql";

  export default {
        data() {
            var checkField = (rule, value, callback) => {

                value = parseFloat(value.replace(',', ''));
                if (!value) {
                    return callback(new Error('Valor requerido'));
                }else {
                    callback();
                }
            };
            return {
                sliderY: 30,
                marks: {
                    10: '10 años',
                    20: '20 años',
                    30: {
                        style: {
                            color: '#1989FA'
                        },
                        label: this.$createElement('strong', '30 años')
                    }
                },

                heightValue: 360,
                widthValue: 600,
                strokeWidth: 1.5,
                tasa_real : 0.40,
                margin : { top: 0, bottom: 20, left: 50, right: 20 },
                width : 600,
                height : 350,

                money: {
                    decimal: '.',
                    thousands: ',',
                    prefix: '',
                    suffix: '$',
                    precision: 2,
                    masked: false
                },
                money_p: {
                    decimal: '.',
                    thousands: '',
                    prefix: '',
                    suffix: '%',
                    precision: 2,
                    masked: false
                },
                ruleForm: {
                    capital: 50000000,
                    tasa_nominal: 900,
                    inflacion: 500,
                    //tasa_real: 0.00,
                    tasa_isr: 3500,
                    tasa_ret_prov: 1.04,
                    rango_tiempo: 30,
                },
                rules: {
                    capital: [
                        { validator: checkField, trigger: 'blur' }
                    ],
                    tasa_nominal: [
                        { validator: checkField, trigger: 'blur' }
                    ],
                    inflacion: [
                        { validator: checkField, trigger: 'blur' }
                    ],
                    //tasa_real: [
                    //    { validator: checkField, trigger: 'blur' }
                    //],
                    tasa_isr: [
                        { validator: checkField, trigger: 'blur' }
                    ],
                    tasa_ret_prov: [
                        { validator: checkField, trigger: 'blur' }
                    ],
                    retiro: [
                        { validator: checkField, trigger: 'blur' }
                    ]
                },

            };
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        //alert('submit!');
                        console.log('submit!!!')
                        this.calculate();
                    } else {
                        console.log('error submit!!');
                        this.$message.error('Datos Incorrectos');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },

            calculate() {
                //console.log("Loading clients", this.listTable)
                const q = this.calculateQuery

                this.$apollo.query({
                    query: q.query,
                    variables: q.variables,
                    fetchPolicy: q.fetchPolicy
                })
                    .then((data) => {
                        //this.successHandler(data.data)
                        let obj = JSON.parse(data.data.calculate.result);
                        // console.log('DATA', data.data)
                        console.log(d3)

                        let check = d3.select("svg");
                        // check if graphs are already loaded
                        let value, value2, value3;
                        let datosTrad = [];
                        let datosAseg = [];
                        let datosDiff = [];

                        for (value in obj.Tradicional) {
                            datosTrad.push(obj.Tradicional[value])}

                        for (value2 in obj.Aseguradora) {
                            datosAseg.push(obj.Aseguradora[value2])}

                        for (value3 in obj.Diferencia) {
                            datosDiff.push(obj.Diferencia[value3])}

                        let graphData = {datosTrad, datosAseg, datosDiff};

                        if (check[0][0] === null) {
                            console.log('NEW', check);

                            this.createGraph(graphData);
                            this.createInfo(graphData);

                        }else{
                           this.updateGraph(graphData);
                           this.createInfo(graphData);
                        }
                    })
                    .catch((error) => { console.log(error) })
            },

            updateGraph(data){
                let yearsRange = this.sliderY;
                const x = d3.scale.linear().range([0, this.width]);
                const x2 = d3.scale.linear().range([0, this.width]);
                const y = d3.scale.linear().range([this.height, 0]);

                d3.svg.axis().orient("left").scale(x);
                d3.svg.axis().orient("top").scale(y);

                x.domain(d3.extent(data.datosAseg, (d, i) => i));
                y.domain([0, d3.max(data.datosAseg, d => d )]);
                x2.domain(d3.extent(data.datosAseg, (d, i) => i+1)); // years starting at 1

                const createPath = d3.svg.line()
                    .x((d, i) => x(i))
                    .y(d => y(d));

                // ########################## UPDATE LINES ###############################
                d3.select(".line-1")
                    .transition()
                    .duration(1000)
                    .attr('d', createPath(data.datosAseg));

                d3.select(".line-2")
                    .transition()
                    .duration(1000)
                    .attr('d', createPath(data.datosTrad));

                // ############################### UPDATE AXIS ##############################
                d3.select(".x.axis")
                    .transition()
                    .duration(1000)
                    .call(d3.svg.axis().scale(x2).orient("bottom").ticks(yearsRange));
                d3.select(".y.axis")
                    .transition()
                    .duration(1000)
                    .call(d3.svg.axis().scale(y).orient("left"));

                // ############################ UPDATE CIRCLES ##############################
                let c1 = d3.select(".circle-1");
                let c2 = d3.select(".circle-2");

                c1.remove();
                c2.remove();
                d3.select(".line-charts")
                    .append('g')
                    .attr('class', 'circle-1')
                    .selectAll("circle") .data(data.datosAseg)
                    .enter().append("circle")
                    .attr("transform", `translate(${this.margin.left},0)`)
                    .attr("r", 3)
                    .attr("cx", function(d,i) {
                        return x(i)
                    })
                    .attr("cy", function(d) {
                        return y(d)
                    })
                    .on("mouseover", function(d,i) {
                        d3.select("#tooltip")
                            .style("right", 300 + "px")
                            //.style("top", yPosition + "px")
                            .select("#valueA")
                            .text("$" + d.toLocaleString("en-US", { minimumFractionDigits: 2 }));
                        d3.select('#tooltip').select("#valueT").text("$" + data.datosTrad[i].toLocaleString("en-US", { minimumFractionDigits: 2 }))
                        d3.select('#tooltip').select("#valueD").text((i+1) + " Años: " + "$" + data.datosDiff[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                        //Show the tooltip
                        d3.select("#tooltip").classed("hidden", false);
                    })
                    .on("mouseout", function() {
                        //Hide the tooltip
                        d3.select("#tooltip").classed("hidden", true);
                    })
                    .transition()
                    .duration(1000);
                    //.exit().remove();

                d3.select(".line-charts")
                    .append('g')
                    .attr('class', 'circle-2')
                    .selectAll("circle") .data(data.datosTrad)
                    .enter().append("circle")
                    .attr("transform", `translate(${this.margin.left},0)`)
                    .attr("r", 3)
                    .attr("cx", function(d,i) {
                        return x(i)
                    })
                    .attr("cy", function(d) {
                        return y(d)
                    })
                    .on("mouseover", function(d,i) {
                        //Update the tooltip position and value
                        d3.select("#tooltip")
                            .style("right", 300 + "px")
                            //.style("top", yPosition + "px")
                            .select("#valueA")
                            .text("$" + data.datosAseg[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                        d3.select('#tooltip').select("#valueT").text("$" + data.datosTrad[i].toLocaleString("en-US", { minimumFractionDigits: 2 }))
                        d3.select('#tooltip').select("#valueD").text((i+1) + " Años: " + "$" + data.datosDiff[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                        //Show the tooltip
                        d3.select("#tooltip").classed("hidden", false);
                    })
                    .on("mouseout", function() {
                        //Hide the tooltip
                        d3.select("#tooltip").classed("hidden", true);
                    })
                    .transition()
                    .duration(1000);

                // ##################################### UPDATE BAR GRAPH #######################################

                let xScale = d3.scale.ordinal()
                    .domain(d3.range(yearsRange))
                    .rangeRoundBands([0, this.width], 0.05);

                let yScale = d3.scale.linear()
                    .domain([0, d3.max(data.datosAseg)])
                    .range([0, this.height]);

                let barHeight = this.height;
                d3.selectAll("rect").remove();
                d3.select(".line-charts")
                    .append("g")
                    .selectAll("rect")
                    .data(data.datosDiff)
                    .enter()
                    .append("rect")
                    .attr("transform", `translate(${this.margin.left},-2)`)
                    .attr("class", "bars")
                    //.transition()
                    //.duration(1000)
                    .attr("x", function(d, i) {
                        return xScale(i) + xScale.rangeBand() / 2;
                    })
                    .attr("y", function(d) {
                        return barHeight - yScale(d);
                    })
                    .attr("width", xScale.rangeBand())
                    .attr("height", function(d) {
                        return yScale(d);
                    })
                    .attr("fill", "#001F5C" )
                    .on("mouseover", function(d,i) {
                        d3.select("#tooltip")
                            .style("right", 300 + "px")
                            //.style("top", yPosition + "px")
                            .select("#valueA")
                            .text("$" + data.datosAseg[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                        d3.select('#tooltip').select("#valueT").text("$" + data.datosTrad[i].toLocaleString("en-US", { minimumFractionDigits: 2 }))
                            .attr("font-family", "sans-serif")
                            .attr("font-size", "20px")
                            .attr("fill", "red");
                        d3.select('#tooltip').select("#valueD").text((i+1) + " Años: " + "$" + data.datosDiff[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                        //Show the tooltip
                        d3.select("#tooltip").classed("hidden", false);
                    })
                    .on("mouseout", function() {
                        //Hide the tooltip
                        d3.select("#tooltip").classed("hidden", true);
                    });
            },

            createGraph(data) {
                let yearsRange = this.sliderY;

                const svg = d3.select(".chartwrapper")
                    .append('svg')
                    //.attr({width: width, height: height})
                    .attr('class', 'charts')
                    //.append('g')
                    //.attr('transform', 'translate(0, 0)')
                    .attr("viewBox", `0 0 ${this.widthValue} ${this.heightValue}`);

                const chart = svg.append("g").attr("transform", `translate(${this.margin.left},10)`);
                const grp = chart
                    .append("g")
                    .attr('class', 'line-charts')
                    .attr("transform", `translate(-${this.margin.left - this.strokeWidth},-${this.margin.top})`);

                const x = d3.scale.linear().range([0, this.width]);
                const x2 = d3.scale.linear().range([0, this.width]);
                const y = d3.scale.linear().range([this.height, 0]);

                d3.svg.axis().orient("left").scale(x);
                d3.svg.axis().orient("top").scale(y);
                x.domain(d3.extent(data.datosAseg, (d, i) => i));
                y.domain([0, d3.max(data.datosAseg, d => d)]);

                const createPath = d3.svg.line()
                    .x((d, i) => x(i))
                    .y(d => y(d));

                // Line GRAPHS ##########################################
                grp.append('path')
                    .attr('d', createPath(data.datosAseg))
                    .transition()
                    .duration(1000)
                    .attr("transform", `translate(${this.margin.left},0)`)
                    .attr('class', 'aseguradora line-1 lines');
                grp.append('path')
                    .attr('d', createPath(data.datosTrad))
                    .transition()
                    .duration(1000)
                    .attr("transform", `translate(${this.margin.left},0)`)
                    .attr('class', 'tradicional line-2 lines');
                // ######################################################

                // Line AXIS
                x2.domain(d3.extent(data.datosAseg, (d, i) => i + 1)); // years starting at 1

                chart.append("g")
                    .attr("class", "x axis")
                    .transition()
                    .duration(1000)
                    .attr("transform", `translate(0,${this.height})`)
                    .call(d3.svg.axis().scale(x2).orient("bottom").ticks(yearsRange));

                chart.append("g")
                    .attr("class", "y axis")
                    .transition()
                    .duration(1000)
                    .attr("transform", `translate(0, 0)`)
                    .call(d3.svg.axis().scale(y).orient("left"));


                grp		// Add the valueline path.
                    .append('g')
                    .attr('class', 'circle-1')
                    .selectAll("circle")
                    .data(data.datosAseg)
                    .enter()
                    .append("circle")
                    .attr("transform", `translate(${this.margin.left},0)`)
                    .attr("r", 3)

                    .attr("cx", function(d,i) {
                        return x(i)
                    })
                    .attr("cy", function(d) {
                        return y(d)
                    })

                    .on("mouseover", function(d,i) {

                        //d3.select(this).attr("fill", "orange");

                        //Get this bar's x/y values, then augment for the tooltip
                        //var xPosition = parseFloat(d3.select(this).attr("cx"));
                        //var yPosition = parseFloat(d3.select(this).attr("cy"));

                        //Update the tooltip position and value
                        d3.select("#tooltip")
                            .style("right", 300 + "px")

                            //.style("top", yPosition + "px")
                            .select("#valueA")
                            .text("$" + d.toLocaleString("en-US", { minimumFractionDigits: 2 }));


                        d3.select('#tooltip').select("#valueT").text("$" + data.datosTrad[i].toLocaleString("en-US", { minimumFractionDigits: 2 }))

                        d3.select('#tooltip').select("#valueD").text((i+1) + " Años: " + "$" + data.datosDiff[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));

                        //Show the tooltip
                        d3.select("#tooltip").classed("hidden", false);


                    })
                    .on("mouseout", function() {
//Hide the tooltip
                        d3.select("#tooltip").classed("hidden", true);
                    });

                grp		// Add the value line path
                    .append('g')
                    .attr('class', 'circle-2')
                    .selectAll("circle")
                    .data(data.datosTrad)
                    .enter()
                    .append("circle")
                    .attr("transform", `translate(${this.margin.left},0)`)
                    .attr("r", 3)
                    .attr("cx", function(d,i) {
                        return x(i)
                    })
                    .attr("cy", function(d) {
                        return y(d)
                    })
                    .on("mouseover", function(d,i) {
                        //Update the tooltip position and value
                        d3.select("#tooltip")
                            .style("right", 300 + "px")
                            //.style("top", yPosition + "px")
                            .select("#valueA")
                            .text("$" + data.datosAseg[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));

                        d3.select('#tooltip').select("#valueT").text("$" + data.datosTrad[i].toLocaleString("en-US", { minimumFractionDigits: 2 }))
                        d3.select('#tooltip').select("#valueD").text((i+1) + " Años: " + "$" + data.datosDiff[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                        //Show the tooltip
                        d3.select("#tooltip").classed("hidden", false);
                    })
                    .on("mouseout", function() {
                        //Hide the tooltip
                        d3.select("#tooltip").classed("hidden", true);
                    });

                //var barWidth = (width / dataset.length);
                // BAR GRAPH #########################################

                let xScale = d3.scale.ordinal()
                    .domain(d3.range(yearsRange))
                    .rangeRoundBands([0, this.width], 0.05);

                let yScale = d3.scale.linear()
                    .domain([0, d3.max(data.datosAseg)])
                    .range([0, this.height]);

                let barHeight = this.height;
                let bar = grp.append("g").selectAll("rect");

                bar.data(data.datosDiff)
                    .enter()
                    .append("rect")
                    .attr("transform", `translate(${this.margin.left},-2)`)
                    .attr("class", "bars")
                    .attr("fill", "#001F5C" )

                    .attr("x", function(d, i) {
                        return xScale(i) + xScale.rangeBand() / 2;
                    })
                    .attr("y", function(d) {
                        return barHeight - yScale(d);
                    })
                    .attr("width", xScale.rangeBand())
                    .attr("height", function(d) {
                        return yScale(d);
                    })
                    .on("mouseover", function(d,i) {

                        d3.select("#tooltip")
                            .style("right", 300 + "px")
                            //.style("top", yPosition + "px")
                            .select("#valueA")
                            .text("$" + data.datosAseg[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));

                        d3.select('#tooltip').select("#valueT").text("$" + data.datosTrad[i].toLocaleString("en-US", { minimumFractionDigits: 2 }))
                            //.attr("font-family", "sans-serif")
                            //.attr("font-size", "20px")
                            //.attr("fill", "red");

                        d3.select('#tooltip').select("#valueD").text((i+1) + " Años: " + "$" + data.datosDiff[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                        //Show the tooltip
                        d3.select("#tooltip").classed("hidden", false);})
                    .on("mouseout", function() {//Hide the tooltip
                        d3.select("#tooltip").classed("hidden", true);
                    })
            },
            createInfo(data){
                d3.select("#cards-info").select("#info1-A").text("Aseguradora: " + "$" + this.formatStringFloat(data.datosAseg[9]));
                d3.select("#cards-info").select("#info1-T").text("Tradicional: " + "$" + this.formatStringFloat(data.datosTrad[9]));
                d3.select("#cards-info").select("#info1-D").text("Diferencia a 10 años: " + "$"
                    + this.formatStringFloat(data.datosDiff[9]) + " (" + this.getPercentage(data.datosAseg[9], data.datosTrad[9]) + "%)");
                d3.select(".card-10").style("visibility", "visible");

                if (data.datosAseg.length >= 20){
                    d3.select("#cards-info").select("#info2-A").text("Aseguradora: " + "$" + this.formatStringFloat(data.datosAseg[19]));
                    d3.select("#cards-info").select("#info2-T").text("Tradicional: " + "$" + this.formatStringFloat(data.datosTrad[19]));
                    d3.select("#cards-info").select("#info2-D").text("Diferencia a 20 años: " + "$"
                        + this.formatStringFloat(data.datosDiff[19]) + " (" + this.getPercentage(data.datosAseg[19], data.datosTrad[19]) + "%)");
                    d3.select(".card-20").style("visibility", "visible");

                } else{
                    d3.select(".card-20").style("visibility", "hidden");
                }
                if (data.datosAseg.length >= 30){
                    d3.select("#cards-info").select("#info3-A").text("Aseguradora: " + "$" + this.formatStringFloat(data.datosAseg[29]));
                    d3.select("#cards-info").select("#info3-T").text("Tradicional: " + "$" + this.formatStringFloat(data.datosTrad[29]));
                    d3.select("#cards-info").select("#info3-D").text("Diferencia a 30 años: " + "$"
                        + this.formatStringFloat(data.datosDiff[29]) + " (" + this.getPercentage(data.datosAseg[29], data.datosTrad[29]) + "%)");
                    d3.select(".card-30").style("visibility", "visible");
                } else{
                    d3.select(".card-30").style("visibility", "hidden");
                }
            },
            getFloat(strFloat){
                return parseFloat(strFloat).toFixed(2)
            },
            formatStringFloat(strFloat){
                return strFloat.toLocaleString("en-US", { minimumFractionDigits: 2 });
            },
            getPercentage(numAseg, numTrad, ){

                return((100 -((numTrad*100)/numAseg))).toFixed(2)
            }
        },
      computed: {
            calculateQuery: function () {
                return{
                    query: getCalculation,
                    variables: {
                        capital: this.getFloat(this.ruleForm.capital.replace(',', '')),
                        tasaNominal: this.getFloat(this.ruleForm.tasa_nominal),
                        inflacion: this.getFloat(this.ruleForm.inflacion),
                        tasaReal: this.getFloat(this.tasa_real),
                        tasaIsr: this.getFloat(this.ruleForm.tasa_isr),
                        tasaRet: this.getFloat(this.ruleForm.tasa_ret_prov),
                        rangoTiempo: this.sliderY
                    },
                    fetchPolicy: 'network-only',
                }
            },
            email: function () {
                return this.$store.getters.userInfo.email
            },
            valid: function(){
                //this.validate();
                return this.listTable
            },
          result: function(){
              return (this.getFloat(this.ruleForm.tasa_nominal) - this.getFloat(this.ruleForm.inflacion)).toFixed(2) + "%";
          }
        },
      mounted() {
          this.width =  this.width - this.margin.left - this.margin.right - (this.strokeWidth * 2);
          this.height = this.height - this.margin.top - this.margin.bottom;
      }
  }
</script>

<style scoped>

  .main {
    margin: 25px 0 38px 50px;
    line-height: 10px;
    //flex-direction: column;
    //justify-content: flex-start;
  }

  .section-header {
    width: 100%;
    margin: 0 auto;
    padding-bottom: 15px;
    //display: flex;
    //flex-direction: column;
    //align-content: flex-center;
    //padding: 10px;
    //overflow:hidden;
  }

  .section-title {
    font-size: 18px;
    font-weight: 600;
    line-height: 16px;
    text-align: start;
  }

  .box-card {
    //width: fit-content;
    //width: calc(100% - 800px);
    margin-bottom: 20px
  }

  .label-title {
    font-size: 12px;
    color : #001F5C;
  }

  .info-card {
    //width: fit-content;
    //height: fit-content;
  //width: calc(100% - 800px);
    visibility: hidden;
    margin-bottom: 10px;
  }

  .info-card p {
    margin: 0;
    //font-family: sans-serif;
    font-size: 14px;
    line-height: 16px;
  }

  .row-info {
    padding-top: 20px;
    padding-bottom: 10px;
  }

  #tooltip {
    position: absolute;
    width: 200px;
    height: auto;
    padding: 10px;
    background-color: white;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    -webkit-box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.4);
    -moz-box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.4);
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.4);
    pointer-events: none;
  }
  #tooltip.hidden {
    display: none;
  }
  #tooltip p {
    margin: 0;
    // font-family: sans-serif;
    font-size: 14px;
    line-height: 16px;
  }

  .card-col /deep/ .el-card {
    border-radius: 20px;
    border: 2px solid #001F5C;
    //width: fit-content;
  }

  .card-col /deep/ .el-card__body{
    padding: 10px;
  }

  .col-form /deep/ .el-form-item__label{

    color: #001c53;
  }

  .col-form /deep/ .el-form-item__content {
    line-height: 14px;
    position: relative;
    font-size: 12px;
  }

  .col-form /deep/ .el-form-item--mini.el-form-item{
    margin-bottom: 4px;
  }

  .col-form /deep/ .el-slider__runway{
    background: #001c53;
  }

  .chartwrapper /deep/ .axis path{
    stroke-width: 1px;
  }

</style>

<style >

  .axis path,
  .axis line {
    fill: none;
    stroke: black;
    shape-rendering: crispEdges;
  }

  .axis text {
    font-family: sans-serif;
    font-size: 8px;
  }

  .chartwrapper path.aseguradora{
    fill: none;
    stroke: #4366de /*$secColor*/;
    stroke-width: 3px;

  }
  .chartwrapper path.tradicional {
    fill: none;
    stroke: #fd6b7d /*$secColor*/;
    stroke-width: 3px;
  }

  .chartwrapper rect.bars{
  //fill: #001F5C;
  //stroke: #20cefd /*$secColor*/;
  //stroke-width: 3px;
  }

  .charts    {
  // border: 1px solid lightgray;
  }

  circle {
    cursor: pointer;
    fill: steelblue;
  }

  circle:hover {
    fill: orange;
  }

  rect:hover {
    fill: orange;
  }

  rect {
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    webkit-transition: all 0.3s;
    transition: all 0.3s;
  }

</style>





// WEBPACK FOOTER //
// src/components/Calculator_Op1.vue